import React from "react"
import {
    Paper,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    makeStyles,
    IconButton
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux"
import VisibilityIcon from '@material-ui/icons/Visibility';
import { SITE_DOMAIN } from "../../../Constantes";
import { actulizarlandingFormAction, targetLandingObjetoAction } from "../../../ducks/landingDuck";
const useStyles = makeStyles({
    root: {
        width: '100%'
    },
    container: {
        maxHeight: 250,
    },
})

const TablaLanding = () => {
    const { listLandingPage } = useSelector(store => store.landing)
    const rows = listLandingPage
    const dispatch = useDispatch()
    const classes = useStyles()
    const onUpdate = ({ landing }) => {
        dispatch(actulizarlandingFormAction({actulizar: true}))
        dispatch(targetLandingObjetoAction({landing: landing }))
    }
    return (
        <TableContainer component={Paper} className={classes.container}>
            <Table size="small" stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                        <TableCell align="left">Nombre</TableCell>
                        <TableCell align="center">Descripcion</TableCell>
                        <TableCell align="center">Url</TableCell>
                        <TableCell align="center">Slug</TableCell>
                        <TableCell align="center"></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, index) => (
                        <TableRow key={row?.IdLanding}>
                            <TableCell align="center">{`${row?.Nombre}`}</TableCell>
                            <TableCell align="center">{`${row?.Descripcion}`}</TableCell>
                            <TableCell align="center">{`${row?.Enlace}`}</TableCell>
                            <TableCell align="center">{`${row?.Slug}`}</TableCell>
                            <TableCell align="center">
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <a href={`${SITE_DOMAIN}${row?.Enlace}`} target="_blank">
                                        <IconButton aria-label="view">
                                            <VisibilityIcon fontSize="medium" />
                                        </IconButton>
                                    </a>
                                    <IconButton aria-label="view" onClick={() => onUpdate({landing: row})}>
                                        <VisibilityIcon fontSize="medium" />
                                    </IconButton>
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
export default TablaLanding
